import {
    Component,
    OnInit,
    OnDestroy,
    ViewChild,
    ViewContainerRef,
    ElementRef
  } from '@angular/core';
  
  // Servicios
  import { DragulaService } from 'ng2-dragula';
  // Components
  import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
  import { DesignAttributeType } from '../../../../types/designer-attribute-type';
  import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
  import { NgxSmartModalService } from 'ngx-smart-modal';
  
  @Component({
    selector: 'modal-designer',
    templateUrl: './modal-designer.component.html'
  })
  export class SxModalDesigner extends SxBaseContainerDesigner
    implements OnInit, OnDestroy {
    @ViewChild('panelContainer', { read: ViewContainerRef })
    private panelContainer: ViewContainerRef;
  
    constructor(
      dragulaService: DragulaService,
      designerFactoryService: IDesignerFactoryService,
      container: ElementRef,
      public ngxSmartModalService: NgxSmartModalService
    ) {
      super(dragulaService, designerFactoryService, 'SxModal', container);
    }
  
    getElementModal(instance: any) {
      this.ngxSmartModalService.setModalData(instance, 'attributesModal');
      this.ngxSmartModalService.getModal('attributesModal').open();
    }
  
    loadDefaults(): void {
      super.loadDefaults();
    }
  
    getDesignerInfo(): any {
      const info = super.getDesignerInfo();
      info['title'] = this.controlContext.title;
      return info;
    }
  
    buildAttributes(): void {
      super.buildAttributes();
  
      const titleAtt = new DesignAttributeType(
        this.controlContext,
        'string',
        'TITLE'
      );
  
      this.attributes.push(titleAtt);
    }
  
    ngOnInit(): void {
      this.placeHolderContainer = this.panelContainer;
      super.ngOnInit();
    }
  
    ngOnDestroy(): void {
      super.ngOnDestroy();
    }
  }


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/modal-designer.component.ts